var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.verifications") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("verifications.lblSIREN"),
                      placeholderValue: _vm.$t("verifications.placeHSIREN"),
                      mandatoryErrorIndicator: _vm.sirenError,
                      regexpErrorIndicator: _vm.sirenRegexpError,
                    },
                    model: {
                      value: _vm.siren,
                      callback: function ($$v) {
                        _vm.siren = $$v
                      },
                      expression: "siren",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("verifications.lblSIRET"),
                      placeholderValue: _vm.$t("verifications.placeHSIRET"),
                      mandatoryErrorIndicator: _vm.siretError,
                      regexpErrorIndicator: _vm.siretRegexpError,
                    },
                    model: {
                      value: _vm.siret,
                      callback: function ($$v) {
                        _vm.siret = $$v
                      },
                      expression: "siret",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("verifications.lblVATNumber"),
                      placeholderValue: _vm.$t("verifications.placeHVATNumber"),
                      mandatoryErrorIndicator: _vm.vatNumberError,
                      regexpErrorIndicator: _vm.vatNumberRegexpError,
                    },
                    model: {
                      value: _vm.vatNumber,
                      callback: function ($$v) {
                        _vm.vatNumber = $$v
                      },
                      expression: "vatNumber",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("verifications.lblSocialReason"),
                      placeholderValue: _vm.$t(
                        "verifications.placeHSocialReason"
                      ),
                      mandatoryErrorIndicator: _vm.socialReasonError,
                      regexpErrorIndicator: _vm.socialReasonRegexpError,
                    },
                    model: {
                      value: _vm.socialReason,
                      callback: function ($$v) {
                        _vm.socialReason = $$v
                      },
                      expression: "socialReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c(
                    "form-write-group-label-input",
                    {
                      attrs: {
                        inputType: "listeSelect",
                        inputLabel: _vm.$t("suppliers.legal_status"),
                      },
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.legal_form,
                              expression: "legal_form",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "sel2", readonly: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.legal_form = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("suppliers.slct_legal_status"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.legalStatusList[_vm.countryCode],
                            function (status) {
                              return _c(
                                "option",
                                {
                                  key: status.code,
                                  domProps: { value: status.code },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(status.label) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group" }, [
                _c("div", [
                  _c("label", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.dt_crtn")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.registration_date,
                        expression: "registration_date",
                      },
                    ],
                    staticClass: "form-control inputAccordionForm",
                    attrs: {
                      type: "date",
                      placeholder: _vm.$t("common.dt_crtn"),
                    },
                    domProps: { value: _vm.registration_date },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.registration_date = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group" },
                [
                  _c(
                    "form-write-group-label-input",
                    {
                      attrs: {
                        inputLabel: _vm.$t("suppliers.core_business"),
                        inputType: "listeSelect",
                      },
                      model: {
                        value: _vm.naf_code,
                        callback: function ($$v) {
                          _vm.naf_code = $$v
                        },
                        expression: "naf_code",
                      },
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.naf_code,
                              expression: "naf_code",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "sel2", readonly: "" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.naf_code = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.$t("suppliers.slct_naf_status"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.nafStatusList[_vm.countryCode],
                            function (status) {
                              return _c(
                                "option",
                                {
                                  key: status.code,
                                  domProps: { value: status.code },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(status.label) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.adrs"),
                      placeholderValue: _vm.$t("common.adrs"),
                    },
                    model: {
                      value: _vm.street_name,
                      callback: function ($$v) {
                        _vm.street_name = $$v
                      },
                      expression: "street_name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.zp_code"),
                      placeholderValue: _vm.$t("common.zp_code"),
                    },
                    model: {
                      value: _vm.zipcode,
                      callback: function ($$v) {
                        _vm.zipcode = $$v
                      },
                      expression: "zipcode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "3" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      inputLabel: _vm.$t("common.cty"),
                      placeholderValue: _vm.$t("common.cty"),
                    },
                    model: {
                      value: _vm.city,
                      callback: function ($$v) {
                        _vm.city = $$v
                      },
                      expression: "city",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "3" } }),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "3" } }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.entities.length > 1
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "font-italic" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("verifications.select_result")) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.entities, function (entity, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "cadreCorporate",
                        staticStyle: { "margin-top": "10px" },
                        on: {
                          click: function ($event) {
                            return _vm.redirectDetails(
                              entity,
                              entity.IdVerificationsHistory
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "h4 text-left",
                                attrs: { sm: "4" },
                              },
                              [
                                _vm._v(
                                  "\n            SIREN : " +
                                    _vm._s(entity.SIRENUnit) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "h4 text-left",
                                attrs: { sm: "8" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(entity.Denomination) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "h6 text-left",
                                attrs: { sm: "4" },
                              },
                              [
                                _vm._v(
                                  "\n            SIRET : " +
                                    _vm._s(entity.SIRET) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "h6 text-left",
                                attrs: { sm: "8" },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(entity.CustomAddress) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "h6 text-left",
                                staticStyle: { "margin-bottom": "0" },
                              },
                              [
                                _vm._v(
                                  "\n            Activité principale : " +
                                    _vm._s(entity.ActivityLabel) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "4",
                    lg: "2",
                    offset: "0",
                    "offset-sm": "8",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "text-center",
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.verificationSend },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("verifications.btnSubVerification")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }